export const serviceLinks = [
  { href: "/services/tax-advisory-planning", label: "Tax Advisory & Planning" },
  { href: "/services/tax-returns-filing", label: "Tax Returns Preparation & Filing" },
  { href: "/services/kra-audit-support", label: "KRA Audit Support & Dispute Resolution" },
  { href: "/services/tax-compliance-health-check", label: "Tax Compliance Health Check" },
  { href: "/services/bookkeeping-accounting", label: "Bookkeeping & Accounting" },
  { href: "/services/payroll-management", label: "Payroll Management & PAYE Compliance" },
  { href: "/services/business-registration", label: "Business Registration & Start-Up Support" },
  { href: "/services/advisory-growth-strategy", label: "Advisory for Growth & Strategy" },
  { href: "/services/corporate-training", label: "Corporate Training & Workshops" },
];

export const navLinks = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/services", label: "Services", hasDropdown: true },
  { href: "/blog", label: "Blog" },
  { href: "/media", label: "Media" },
  { href: "/resources", label: "Resources" },
  { href: "/contact", label: "Contact" },
];